import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import useSWR from "swr";
import { BASE_URL, fetcher } from "../../../Models/Fetcher";

interface ISelectCustomerProps {
  handleChange: any;
  displayAll?: boolean;
}

export default ({ handleChange, displayAll = true }: ISelectCustomerProps) => {
  const { data, error } = useSWR(BASE_URL + "customers", fetcher);

  if (!data) {
    return <div>Loading</div>;
  }
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Customer</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        defaultValue={""}
        onChange={handleChange}
        className="select-form"
      >
        {displayAll && (
          <MenuItem key={0} value={0}>
            All customers
          </MenuItem>
        )}
        {data.map((option: any) => {
          return (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
